<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="white",
    absolute,
    top
  )
  v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
    v-col.py-0.text-right
      v-btn.mr-2(color="white", @click="save", :disabled="loading") {{ $t('Common.submit') }}
  v-row(v-show="!loading")
    v-col.py-0
      v-card.elevation-24.mb-5(style="overflow: hidden")
        app-full-entity(:entity="sectionedEntity", :ignoreTabs="portalIgnoreTabs", v-bind="{ customLabel, tabsProps }")
          template(v-slot:Portal="props")
            app-entity(
              :extra-data="false",
              v-bind="props",
            )
              template(v-slot:addFields)
                v-row
                  v-col(cols="3")
                    v-text-field(
                      :value="instance.name",
                      @input="input($event, 'name')"
                      :label="$t('Portal.name')",
                    )
                  v-col(cols="6")
                    v-text-field(
                      :value="instance.description",
                      @input="input($event, 'description')"
                      :label="$t('Portal.description')",
                    )
                  v-col(cols="3")
                    v-select(
                      :value="instance.businessScope",
                      @input="input($event, 'businessScopeId')",
                      :items= "businessScopes",
                      :label="$t('Portal.description')",
                      item-text="path",
                      item-value="id",
                      :error-messages="errors['BusinessScopeId']",
                      :error="!!errors['BusinessScopeId']"
                    )
                v-row
                  v-col
                    v-select(
                      :value="instance.entity",
                      @input="input($event.name, 'entity')",
                      :label="$t('Portal.entity')",
                      :items="filteredEntities"
                      item-text="name",
                      return-object,
                    )
                  v-col
                    v-text-field(
                      :label="$t('Portal.createdAt')",
                      :value="instance.createdAt",
                      disabled,
                    )
                  v-col
                    v-text-field(
                      :label="$t('Portal.modifiedAt')",
                      :value="instance.modifiedAt",
                      disabled,
                    )
                  v-col
                    v-text-field(
                      :label="$t('Portal.userFullName')",
                      :value="instance.createdBy",
                      disabled,
                    )
            template(v-if="!loading")
              template(v-for="section in props.sections")
                app-entity-relation(:path="section.name", :parent="props.entity", :parent-instance="props.value", :relation="section", :entity="$findEntity(section.type)", :criteriaEntityName="(selectedEntity || {}).name")
          template(v-slot:fields="props")
            tabs-management(:value="instanceTabs", :fields="instanceEntityTabs", :entity="selectedEntity", @input="inputFields($event, 'instanceTabs')")
          template(v-slot:fieldLabeling="props")
            field-labeling(:value="instancePrimitives", :fields="instanceEntityPrimitives", @input="inputFields($event, 'instancePrimitives')")
          template(v-slot:extraFields="props")
            extra-fields(:value="instanceExtraFields", :fields="instanceEntityExtraFields", @input="inputFields($event, 'instanceExtraFields')")
</template>

<script>
import axios from 'axios'
import EntityMixin from '@/mixins'
import TabsManagement from './TabsManagement'
import FieldLabeling from './FieldLabeling'
import ExtraFields from './ExtraFields'

export default {
  name: 'AddPortal',
  mixins: [EntityMixin],
  components: {
    TabsManagement,
    FieldLabeling,
    ExtraFields,
  },

  /**
   * The data object for the Vue instance.
   * Vue will recursively convert its properties
   * into getter/setters to make it “reactive”
   * and these methods directly via "this".
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/#data}
   * @member {Object<mixed>}
   * @memberOf Foo
   */

  data: function () {
    return {
      loading: true,
      portalIgnoreTabs: [],
      customLabel: {
        // fields: 'Tabs Management',
      },

      customAdditionalTabs: [
        { name: "fieldLabeling" , type: "fieldLabeling", fields:[]},
        { name: "extraFields" , type: "extraFields", fields:[]},
      ],

      tabsProps: {
        backgroundColor: 'grisClair',
        color: 'primaryHover',
        dark: false,
      },

      sections: {
        criterias: "Portal",
      },

      businessScopes: [],
    }
  },

  /*
   * Computed properties to be mixed into the Vue instance.
   * All getters and setters have their this context
   * automatically bound to the Vue instance.
   * Note that if you use an arrow function with a computed property,
   * this won’t be the component’s instance
   * <br> ------------------------------ <br>
   * {@link https://vuejs.org/v2/api/?#computed}
   * @member {Object<mixed>}
   * @memberOf Foo
   */
  computed: {
    filteredEntities () {
      return _.chain(this.entityList).filter(e => e.name === 'Shipment').value()
    },
    entityList () {
      return this.$store.state.schema.all || []
    },
    selectedEntity() {
      const selected = _.get(this.instance, 'entity');
      if (!selected) return null;
      return this.entityList.find(x => x.name === selected);
    },
    entityName () {
      return 'Portal'
    },
    entity () {
      return this.$findEntity('Portal');
    },
    entityWithoutPrimitives() {
      const entityCopy = { ...this.entity };
      entityCopy.fields = this.$fields(entityCopy).filter(f => !f.primitive);
      return entityCopy;
    },
    entityHideTabs() {
      const entityCopy = { ...this.entityWithoutPrimitives };
      entityCopy.fields = entityCopy.fields.filter(f => {
        if (['fields'].includes(f.name) && !this.selectedEntity) return false;
        return true;
      });

      if (this.selectedEntity) {
        entityCopy.fields = [...entityCopy.fields, ...this.customAdditionalTabs];
      }

      return entityCopy;
    },
    sectionedEntity() {
      let entityCopy = { ...this.entityHideTabs };
      entityCopy.fields = this.$sectionedFields(entityCopy, this.sections)
      return entityCopy;
    },
    uid () {
      return this.$route.params.item
    },
    errors() {
      return this.$store.state.errors;
    },
    instanceTabs() {
      const fields = _.get(this.instance, 'fields', []);
      return fields.filter(f => !f.primitive && !f.section && !f.extra);
    },
    instancePrimitives() {
      const fields = _.get(this.instance, 'fields', []);
      return fields.filter(f => f.primitive && !f.extra);
    },
    instanceExtraFields() {
      const fields = _.get(this.instance, 'fields', []);
      return fields.filter(f => f.extra);
    },
    instanceEntityTabs() {
      let tabs = null;
      if (this.selectedEntity && (tabs = _.get(ENV.ENTITIES[this.selectedEntity.name], 'portal.tabs'))) {
        return tabs;
      }
      return this.$fields(this.selectedEntity).filter(f => !f.primitive && !f.section && !f.extra);
    },
    instanceEntityPrimitives() {
      return this.$fields(this.selectedEntity).filter(f => f.primitive);
    },
    instanceEntityExtraFields() {
      return this.$fields(this.selectedEntity).filter(f => f.extra);
    },
  },
  methods: {
    input($event, path) {
      this.$store.commit(this.setInstancePathAction, { path, value: $event });
    },
    inputFields($event, type) {
      // console.log('INPUT FIELDS ', type);
      // console.log('Event' , $event);
      const instanceTabs = type === 'instanceTabs' ? [...$event] : [...this.instanceTabs];
      const instancePrimitives = type === 'instancePrimitives' ? [...$event] : [...this.instancePrimitives];
      const instanceExtraFields = type === 'instanceExtraFields' ? [...$event] : [...this.instanceExtraFields];
      this.$store.commit(this.setInstancePathAction, { path: 'fields', value: [...instanceTabs, ...instancePrimitives, ...instanceExtraFields] });
    },
    initInstance () {
      return {
        _Entity: this.entity.name,
        ...this.portal,
        userId: this.$store.state.user.user.id,
        entityState: this.portal && this.portal.id
          ? ENV.ENTITY.STATE.UNCHANGED
          : ENV.ENTITY.STATE.ADDED
      }
    },
    async save () {
      try {
        this.loading = true
        let _portal = { ...this.instance, _fields: JSON.stringify(this.instance.fields) }
        await axios.post('entity/graph', _portal)
        // let res = await this.$store.dispatch(action, _portal);
        await this.$updateSchema(this.$store, axios)
        this.$router.push({ name: 'entities.index', params: { entity: 'Portal' } });
      } catch (errors) {
        // this.errors = errors.response.data.errors
      } finally {
        this.loading = false
      }
    },
    async load () {
      try {
        // this.loadingInfo = true;
        this.loading = true;
        ({ data: { data: this.businessScopes } } = await axios.get('BusinessScopes', { params: { pageSize: -1 } }));
        if (this.uid) {
          let _instance = (await axios.get(`${this.entity.name}/${this.uid}?load[]=User`, {
            _Entity: this.entity.name,
            uid: this.uid
          })).data
          this.instance = { ..._instance, entityState: 3 };
        }
      } finally {
        // this.loadingInfo = false;
        this.loading = false;
      }
    },
    async getBusinessScope(businessScopeId){
      if(businessScopeId == null) return null;
      let bs = (await axios.get('BusinessScope?where[]=id=' + businessScopeId)).data.data;
      return bs[0];
    },
  },
  async created () {
    const lsbusinessScopeId = window.localStorage.getItem("BusinessScopeId");
    const lsbusinessScope = await this.getBusinessScope(lsbusinessScopeId);

    const baseInstance = {
      entityState: 4,
      _Entity: this.entity.name,
      user: this.$store.state.user.user,
      businessScopeId: lsbusinessScopeId,
      businessScope: lsbusinessScope,
    }
    this.$store.commit('SET_INSTANCE', baseInstance);

    await this.load();
  }
}
</script>
